import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';
import type { VarianceDto } from '../types/BankingDto';

export function useVarianceForm(variance: VarianceDto) {
	const [inputs, setInputs] = useState<VarianceDto>({
		...variance,
	});

	const form = useForm<VarianceDto>({
		mode: 'uncontrolled',
		initialValues: variance,
		validate: {
			cash: (value) => validateNumber(value, false, -1000000, 1000000, 'Cash'),
			cashInvoices: (value) =>
				validateNumber(value, false, -1000000, 1000000, 'Cash invoices'),
			floatHead: (value) =>
				validateNumber(value, false, -1000000, 1000000, 'Float held'),
			changeHeld: (value) =>
				validateNumber(value, false, -1000000, 1000000, 'Change held'),
			varReason: (value) => validateText(value, false, 'Variance reason'),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
